import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSession } from '../../services/auth';
import './NavBar.css';

const NavBar: React.FC = () => {
  const location = useLocation();
  const { isManagerLoggedIn, logout, user } = useSession();

  const isActive = (path: string): boolean => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span className="navbar-icon">🏕️</span>
        <h1 className="navbar-title">Saco River Hideaway Campground</h1>
      </div>

      {isManagerLoggedIn && (
        <>
          <div className="navbar-links">
            <Link
              to="/"
              className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            >
              Home
            </Link>
            <Link
              to="/reservations"
              className={`navbar-link ${isActive('/reservations') ? 'active' : ''}`}
            >
              Reservations
            </Link>
            <Link
              to="/daily-report"
              className={`navbar-link ${isActive('/daily-report') ? 'active' : ''}`}
            >
              Daily Report
            </Link>
            <Link
              to="/analysis"
              className={`navbar-link ${isActive('/analysis') ? 'active' : ''}`}
            >
              Analysis
            </Link>
            <Link
              to="/members"
              className={`navbar-link ${isActive('/members') ? 'active' : ''}`}
            >
              Members
            </Link>
            <Link
              to="/sites"
              className={`navbar-link ${isActive('/sites') ? 'active' : ''}`}
            >
              Sites
            </Link>
            <Link
              to="/config"
              className={`navbar-link ${isActive('/config') ? 'active' : ''}`}
            >
              Configuration
            </Link>
          </div>

          <div className="navbar-user">
            <span className="user-name">
              {user?.first_name} {user?.last_name}
            </span>
            <button className="logout-button" onClick={logout}>
              Logout
            </button>
          </div>
        </>
      )}
    </nav>
  );
};

export default NavBar;
